import { Divider as DividerComp } from "@theorgchartdev/storybook";
import { ComponentProps } from "react";

export const Divider = (props: ComponentProps<typeof DividerComp>) => (
  <div className="ocn-toolbar-horizontal-divider">
    <DividerComp vertical={true} {...props} />
  </div>
);
